import { StoryTypeByAgeEnum, StoryTypeEnum, WritingStyleEnum } from '../../../interfaces/book.interface';

export const storyExample = (type: string, key: any) => {
  switch (type) {
    case StoryTypeByAgeEnum.CHILD_AGE:
      return (
        <h1 className=" flex text-base text-storyblue m-4">
          These are the page totals available for the reading age selected
          <br />
          {key.map((obj: { key: string }) => obj.key).join(', ')} Pages
        </h1>
      );
    case StoryTypeByAgeEnum.STORY:
      switch (key) {
        case StoryTypeEnum.bedtime:
          return (
            <h1 className="text-base text-storyblue m-4">
              A bedtime story is a soothing tale told before sleep, often filled with whimsical characters
              and
              gentle morals to lull children into peaceful dreams.
            </h1>
          );
        case StoryTypeEnum.fable:
          return (
            <h1 className="text-base text-storyblue m-4">
              A fable is a short narrative that uses animals, plants, or inanimate objects as characters
              to
              convey moral lessons or teach ethical principles in a simple and allegorical manner.
            </h1>
          );
        case StoryTypeEnum.fairytale:
          return (
            <h1 className="text-base text-storyblue m-4">
              A fairy tale is a fantastical narrative often featuring magical elements, enchanting
              characters,
              and timeless themes of adventure, love, and triumph over adversity.
            </h1>
          );
        case StoryTypeEnum.adventure:
          return (
            <h1 className="text-base text-storyblue m-4">
              An adventure story is a thrilling narrative that follows characters through exciting and
              often
              perilous journeys, brimming with action, exploration, and unexpected twists.
            </h1>
          );
        case StoryTypeEnum.educational:
          return (
            <h1 className="text-base text-storyblue m-4">
              An educational story is a narrative crafted to both entertain and inform, conveying
              knowledge or
              moral lessons through engaging characters, plots, and settings.
            </h1>
          );
        case StoryTypeEnum.mystery:
          return (
            <h1 className="text-base text-storyblue m-4">
              A mystery story is a suspenseful narrative that revolves around solving a puzzling crime or
              uncovering hidden truths through clues, twists, and unexpected revelations.
            </h1>
          );
        case StoryTypeEnum.science_fiction:
          return (
            <h1 className="text-base text-storyblue m-4">
              A science fiction story is a speculative narrative set in a future or alternate reality,
              exploring imaginative concepts, advanced technology, and extraterrestrial phenomena to
              contemplate the possibilities of science and society.
            </h1>
          );
        case StoryTypeEnum.realistic_fiction:
          return (
            <h1 className="text-base text-storyblue m-4">
              A realistic fiction story is a narrative grounded in everyday life and plausible events,
              focusing on relatable characters, situations, and themes to explore the complexities of
              human
              experience.
            </h1>
          );
        default:
          return null;
      }
    case StoryTypeByAgeEnum.WRITING_STYLE:
      switch (key) {
        case WritingStyleEnum.imaginative:
          return (
            <h1 className="text-base text-storyblue m-4">
              Imaginative writing whisks readers to vibrant worlds with vivid descriptions, inventive
              language, and unconventional storytelling, sparking creativity and captivating imaginations.
            </h1>
          );
        case WritingStyleEnum.funny:
          return (
            <h1 className="text-base text-storyblue m-4">
              Funny writing uses wit, humor, and clever wordplay to make readers laugh, infusing stories
              with
              comedic elements and playful storytelling techniques.
            </h1>
          );
        case WritingStyleEnum.heartwarming:
          return (
            <h1 className="text-base text-storyblue m-4">
              User create a shorter description of funny writing style.
            </h1>
          );
        case WritingStyleEnum.action_packed:
          return (
            <h1 className="text-base text-storyblue m-4">
              The action-packed writing style thrills readers with dynamic pacing, vivid descriptions, and
              fast-paced plot twists, ensuring constant excitement and momentum.
            </h1>
          );
        case WritingStyleEnum.nostalgic:
          return (
            <h1 className="text-base text-storyblue m-4">
              The nostalgic writing style stirs longing for the past with vivid details and a wistful
              tone,
              taking readers on sentimental journeys to cherished memories and bygone eras.
            </h1>
          );
        case WritingStyleEnum.empowering:
          return (
            <h1 className="text-base text-storyblue m-4">
              Empowering writing inspires resilience, strength, and positive change, motivating readers to
              overcome challenges and embrace their potential for transformation in their lives and
              communities.
            </h1>
          );
        case WritingStyleEnum.spooky:
          return (
            <h1 className="text-base text-storyblue m-4">
              Spooky writing chills with eerie descriptions, suspenseful pacing, and supernatural
              elements,
              immersing readers in macabre tales that evoke fear and fascination.
            </h1>
          );
        case WritingStyleEnum.educational:
          return (
            <h1 className="text-base text-storyblue m-4">
              Educational writing enlightens with clear explanations, engaging examples, and structured
              content, simplifying complex subjects for accessibility while ensuring readability.
            </h1>
          );
        default:
          return null;
      }

    case StoryTypeByAgeEnum.ART_STYLE:
      return (
        <img
          src={key?.sref_image}
          alt="Art Style"
          className="w-[15rem] h-[15rem] md:w-[20rem] md:h-[20rem] rounded-lg"
        />
      );
    default:
      break;
  }
};